import React, { useEffect, useState } from 'react'
import '../static/style/skills.css'
import {db} from '../firbase-conf'
import {collection, getDocs} from "firebase/firestore"

function Skills() {
    const [skills , setskills] = useState([])
    const skillsCollectionRsf = collection(db ,"skills")
    useEffect(() =>{
        const getskills = async()=>{
            const data = await getDocs(skillsCollectionRsf)
            setskills(data.docs.map((doc)=>({...doc.data(), id:doc.id})))
        }

        getskills()
    },[])
  return (
    <div className='skill__content'>
        <div className='head'>
                <h2>Skills</h2>
        </div>
        <div className='skills'>
            {skills?.map((skill)=>{
                return (
                    <div className='skill'>
                            <img src={skill.img}/>
                    </div>
                )})}
        </div>
    </div>
  )
}

export default Skills